import React from 'react';
import { Redirect } from 'react-router-dom';

import jsCookie from 'js-cookie';

const withAuthentication = (Component) => (props) => {
  const isAuthenticated = jsCookie.get('isAuthenticated');

  if (
    !isAuthenticated &&
    props.location &&
    !props.location.pathname.includes('/builds/') &&
    !window.location.pathname.includes('/login/')
  ) {
    sessionStorage.setItem('initialPathName', window.location.pathname);
  }

  const userType = localStorage.getItem('userType');
  const redirectTo = userType === 'customer' ? '/login/customer/' : '/login/employee/';

  if (
    !isAuthenticated &&
    props.location &&
    !props.location.pathname.includes('/builds/') &&
    !props.location.pathname.includes('/login/')
  ) {
    return <Redirect to={redirectTo} />;
  }

  return <Component {...props} />;
};

export default withAuthentication;
